import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Constants from "../../Constants";
import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import ToothFairyButton from "./ToothFairyButton";
import { useTranslation } from "react-i18next";
import useWorkspaces from "../../Hooks/useWorkspaces";
const BatchDownloadModalContent = ({
  type,
  onSelectionChange = () => {},
  enabled = true,
  selection = [],
  handleFormSubmit = () => {},
  filesResult = [],
  context,
}) => {
  const AppToasty = AppToast.useToast();
  const { t, i18n } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const { isModelDownloadEnabled } = useWorkspaces();
  const fileAvailable = (item, filesResult) => {
    console.log("CONEXT", item, filesResult);
    if (context === "batch" && filesResult?.Contents) {
      const filesInS3 = filesResult?.Contents?.map(
        (u) => u?.Key?.split("/")[u?.Key?.split("/").length - 1]
      );
      filesInS3.push("input.csv");
      // match the entries in both the arrays and generate a new one with the matching entries
      if (filesInS3.includes(item?.filename)) {
        return true;
      }
    } else if (context === "training" && filesResult?.Contents) {
      const filesInS3 = filesResult?.Contents?.map(
        (u) => u?.Key?.split("/")[u?.Key?.split("/").length - 1]
      );
      if (filesInS3.includes(item?.filename)) {
        return true;
      }
    }
  };
  const baseFiles =
    context === "batch"
      ? Constants.BATCH_DOWNLOAD_OPTIONS
      : Constants.DOWNLOAD_OPTIONS;
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      paddingHorizontal: 24,
      paddingVertical: 16,
    },
    header: {
      marginBottom: 20,
      paddingBottom: 16,
      borderBottomWidth: 1,
      borderBottomColor: currentTheme?.theme?.mediumGrey || "#f0f0f0",
    },
    headerText: {
      fontWeight: "600",
      color: currentTheme?.theme?.font_color || "#333",
      marginBottom: 4,
    },
    subtitle: {
      fontSize: 14,
      color: currentTheme?.theme?.mediumGrey || "#666",
    },
    fileList: {
      flex: 1,
      marginBottom: 24,
    },
    fileItem: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 8,
      paddingHorizontal: 16,
      marginBottom: 8,
      backgroundColor: currentTheme?.theme?.backgroundColor || "#fff",
      borderRadius: 8,
      borderWidth: 1,
      borderColor: currentTheme?.theme?.mediumGrey || "#e5e5e5",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.05,
      shadowRadius: 2,
      elevation: 1,
    },
    fileItemSelected: {
      borderColor: currentTheme?.theme?.primary || "#007bff",
      backgroundColor: currentTheme?.theme?.primaryLight || "#f0f8ff",
    },
    fileItemDisabled: {
      opacity: 0.5,
      backgroundColor: currentTheme?.theme?.lightGrey || "#f8f9fa",
    },
    checkboxIcon: {
      marginRight: 12,
    },
    fileItemContent: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
    },
    fileName: {
      fontWeight: "bold",
      color: currentTheme?.theme?.font_color || "#333",
      marginBottom: -1,
      marginLeft: 8,
    },
    fileNameDisabled: {
      color: currentTheme?.theme?.darkGrey || "#999",
    },
    fileType: {
      fontSize: 12,
      color: currentTheme?.theme?.mediumGrey || "#666",
      textTransform: "uppercase",
    },
    buttonContainer: {
      paddingTop: 16,
      borderTopWidth: 1,
      borderTopColor: currentTheme?.theme?.mediumGrey || "#f0f0f0",
      alignItems: "center",
    },
    selectionSummary: {
      marginBottom: 16,
      paddingHorizontal: 12,
      paddingVertical: 8,
      backgroundColor: currentTheme?.theme?.lightBlue || "#e3f2fd",
      borderRadius: 6,
      alignSelf: "center",
    },
    selectionText: {
      fontSize: 13,
      color: currentTheme?.theme?.primary || "#007bff",
      fontWeight: "500",
    },
  });

  const availableFiles = baseFiles.filter(
    (i) => i.type === type || i.type === "ALL"
  );
  const selectedCount = selection.length;

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <AppText preventTranslation style={styles.headerText}>
          Select files to download
        </AppText>
        <AppText preventTranslation style={styles.subtitle}>
          Choose the {context === "batch" ? "batch processing" : "training"}{" "}
          files you need
        </AppText>
      </View>

      <View style={styles.fileList}>
        {availableFiles.map((i) => {
          const isSelected = selection.includes(i.id);
          const isAvailable = fileAvailable(i, filesResult);
          const isEnabled = enabled && isAvailable;

          return (
            <TouchableOpacity
              key={i.id || i.toString()}
              style={[
                styles.fileItem,
                isSelected && styles.fileItemSelected,
                !isAvailable && styles.fileItemDisabled,
              ]}
              preventTranslation
              onPress={() => {
                if (!isEnabled) return;

                if (!isModelDownloadEnabled() && i.id === "MODEL") {
                  AppToasty.show(t("modelDownloadDisabled"), {
                    placement: "bottom",
                    type: "warning",
                  });
                  return;
                }

                let newSelection;
                if (selection.includes(i.id)) {
                  newSelection = selection.filter((j) => j !== i.id);
                } else {
                  newSelection = [...selection, i.id];
                }
                onSelectionChange(newSelection);
              }}
              disabled={!isEnabled}
            >
              <AppText
                preventTranslation
                wrapperStyle={styles.fileItemContent}
                leftIcon={
                  isSelected
                    ? AppAssets?.icons?.check
                    : AppAssets?.icons?.uncheck
                }
                leftIconColor={
                  isSelected && isEnabled
                    ? currentTheme?.theme?.primary || "#007bff"
                    : currentTheme?.theme?.grey || "#999"
                }
                leftIconStyle={styles.checkboxIcon}
                style={[
                  styles.fileName,
                  !isAvailable && styles.fileNameDisabled,
                ]}
                iconSize={14}
              >
                {i.label || i.toString()}
              </AppText>
              <AppText preventTranslation style={styles.fileType}>
                {i.type} • {i.filename}
              </AppText>
            </TouchableOpacity>
          );
        })}
      </View>

      <View style={styles.buttonContainer}>
        {
          <View style={styles.selectionSummary}>
            <AppText preventTranslation style={[styles.selectionText]}>
              {selectedCount > 0
                ? `${selectedCount} file${
                    selectedCount !== 1 ? "s" : ""
                  } selected`
                : "No file selected"}
            </AppText>
          </View>
        }

        <ToothFairyButton
          onPress={handleFormSubmit}
          wrapperStyle={{
            minWidth: 140,
          }}
          title={"Download"}
          disabled={selectedCount === 0}
        />
      </View>
    </View>
  );
};

export default BatchDownloadModalContent;
